import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const MESES = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre',
];

function formatFecha(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(String(dateStr).slice(0, 10) + 'T12:00:00');
  return `${d.getDate()} ${MESES[d.getMonth()]} ${d.getFullYear()}`;
}

export default function Bitacoras() {
  const navigate = useNavigate();
  const [comunidades, setComunidades]     = useState([]);
  const [ascensores, setAscensores]       = useState([]);
  const [comunidadSel, setComunidadSel]   = useState(null);
  const [ascensorSel, setAscensorSel]     = useState(null);
  const [formularios, setFormularios]     = useState([]);
  const [loadingForms, setLoadingForms]   = useState(false);
  const [errorForms, setErrorForms]       = useState(false);
  const [busqueda, setBusqueda]           = useState('');
  const [loading, setLoading]             = useState(true);
  const [filtroDesde, setFiltroDesde]     = useState('');
  const [filtroHasta, setFiltroHasta]     = useState('');
  const [filtroActivo, setFiltroActivo]   = useState(false);

  useEffect(() => {
    api.get('/ascensores').then(r => {
      const data = r.data || [];
      setAscensores(data);
      const map = {};
      data.forEach(a => {
        if (!map[a.comunidad]) map[a.comunidad] = {
          comunidad: a.comunidad, direccion: a.direccion,
          comuna: a.comuna, ascensores: [],
        };
        map[a.comunidad].ascensores.push(a);
      });
      setComunidades(Object.values(map).sort((a, b) =>
        a.comunidad.localeCompare(b.comunidad)
      ));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fetchBitacora = async (ascensor, desde = '', hasta = '') => {
    setLoadingForms(true);
    setErrorForms(false);
    try {
      const params = {};
      if (desde) params.desde = desde;
      if (hasta) params.hasta = hasta;
      const r = await api.get(`/ascensores/${ascensor.id}/bitacora`, { params });
      setFormularios(r.data);
    } catch {
      setFormularios([]);
      setErrorForms(true);
    } finally {
      setLoadingForms(false);
    }
  };

  const abrirBitacora = (ascensor) => {
    setAscensorSel(ascensor);
    setFormularios([]);
    setErrorForms(false);
    setFiltroDesde('');
    setFiltroHasta('');
    setFiltroActivo(false);
    fetchBitacora(ascensor);
  };

  const aplicarFiltro = () => {
    setFiltroActivo(!!(filtroDesde || filtroHasta));
    fetchBitacora(ascensorSel, filtroDesde, filtroHasta);
  };

  const limpiarFiltro = () => {
    setFiltroDesde('');
    setFiltroHasta('');
    setFiltroActivo(false);
    fetchBitacora(ascensorSel);
  };

  const filtradas = comunidades.filter(c =>
    c.comunidad.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.comuna?.toLowerCase().includes(busqueda.toLowerCase())
  );

  const ascensoresDeComunidad = ascensores.filter(
    a => a.comunidad === comunidadSel?.comunidad
  );

  const inputDate = {
    padding: '7px 10px', border: '1.5px solid #2E4A40',
    borderRadius: 8, fontSize: 13, fontFamily: 'inherit',
    background: '#0D1311', color: '#F4F7F5', outline: 'none',
  };

  // ── Vista: historial de un ascensor ──────────────────────────────────────────
  if (ascensorSel) {
    return (
      <div className="app-container">
        <div className="app-header">
          <button onClick={() => setAscensorSel(null)} className="back-btn">←</button>
          <h1>📋 {ascensorSel.label}</h1>
        </div>

        <div style={{ background: '#0f6e56', padding: '8px 16px' }}>
          <p style={{ margin: 0, color: 'rgba(255,255,255,0.85)', fontSize: 12 }}>
            {ascensorSel.comunidad} · N° {ascensorSel.n_ascensor} · Torre {ascensorSel.torre}
          </p>
        </div>

        {/* Filtro de fechas */}
        <div style={{
          background: '#111714', padding: '12px 16px',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
          display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-end',
        }}>
          <div>
            <label style={{ display: 'block', fontSize: 11, color: '#6B7C74',
              fontWeight: 600, marginBottom: 4, textTransform: 'uppercase',
              letterSpacing: '0.5px' }}>Desde</label>
            <input type="date" value={filtroDesde}
              onChange={e => setFiltroDesde(e.target.value)}
              style={inputDate} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 11, color: '#6B7C74',
              fontWeight: 600, marginBottom: 4, textTransform: 'uppercase',
              letterSpacing: '0.5px' }}>Hasta</label>
            <input type="date" value={filtroHasta}
              onChange={e => setFiltroHasta(e.target.value)}
              style={inputDate} />
          </div>
          <button onClick={aplicarFiltro}
            disabled={!filtroDesde && !filtroHasta}
            style={{
              padding: '8px 16px', background: '#0f6e56', color: 'white',
              border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600,
              cursor: (!filtroDesde && !filtroHasta) ? 'default' : 'pointer',
              opacity: (!filtroDesde && !filtroHasta) ? 0.35 : 1,
              fontFamily: 'inherit',
            }}>
            Filtrar
          </button>
          {filtroActivo && (
            <button onClick={limpiarFiltro}
              style={{
                padding: '8px 14px', background: 'none',
                border: '1.5px solid #2E4A40', borderRadius: 8,
                fontSize: 13, color: '#8A9994', cursor: 'pointer',
                fontFamily: 'inherit',
              }}>
              × Limpiar
            </button>
          )}
          {filtroActivo && !loadingForms && (
            <span style={{ fontSize: 12, color: '#4CAF50', alignSelf: 'center' }}>
              {formularios.length} resultado{formularios.length !== 1 ? 's' : ''}
            </span>
          )}
        </div>

        <div className="page-content" style={{ padding: 12 }}>
          {loadingForms ? (
            <div style={{ textAlign: 'center', paddingTop: 40 }}>
              <div className="spinner" />
            </div>
          ) : errorForms ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <p style={{ color: '#EF4444', fontSize: 14 }}>
                Error al cargar los registros. Intenta nuevamente.
              </p>
            </div>
          ) : formularios.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '48px 20px' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
              <p style={{ color: '#8A9994', fontSize: 14 }}>
                Sin registros para este ascensor
              </p>
            </div>
          ) : (
            formularios.map(f => (
              <div key={f.id} style={{
                background: '#161C19', borderRadius: 14, padding: 14, marginBottom: 10,
                border: '1px solid rgba(255,255,255,0.07)',
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between',
                  alignItems: 'flex-start', marginBottom: 8 }}>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    <span style={{
                      fontSize: 11, fontWeight: 700,
                      background: f.tipo === 'mantenimiento' ? '#12382D' : '#0D1E2E',
                      color: f.tipo === 'mantenimiento' ? '#4CAF50' : '#38BDF8',
                      borderRadius: 20, padding: '2px 8px',
                    }}>
                      {f.tipo === 'mantenimiento' ? '🔧 Mantenimiento' : '📋 Visita Técnica'}
                    </span>
                    {f.tiene_rai && (
                      <span style={{
                        fontSize: 11, fontWeight: 700,
                        background: '#2D0F0F', color: '#EF4444',
                        borderRadius: 20, padding: '2px 8px',
                      }}>
                        ⚠ RAI
                      </span>
                    )}
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 800, color: '#4CAF50' }}>#{f.id}</div>
                    {f.folio && <div style={{ fontSize: 10, color: '#6B7C74' }}>{f.folio}</div>}
                  </div>
                </div>

                <div style={{ fontSize: 13, fontWeight: 600, color: '#F4F7F5', marginBottom: 1 }}>
                  {formatFecha(f.fecha_visita)}
                  {f.hora_ingreso && (
                    <span style={{ fontWeight: 400, color: '#8A9994', marginLeft: 8 }}>
                      {f.hora_ingreso}{f.hora_salida ? ` - ${f.hora_salida}` : ''}
                    </span>
                  )}
                </div>
                {f.created_at && (
                  <div style={{ fontSize: 11, color: '#6B7C74', marginBottom: 3 }}>
                    Enviado: {String(f.created_at).slice(0, 10).split('-').reverse().join('/')}
                  </div>
                )}
                <div style={{ fontSize: 12, color: '#8A9994' }}>
                  Técnico: {f.tecnico_nombre}
                </div>

                {(f.resumen_visita || f.observaciones_generales) && (
                  <div style={{
                    marginTop: 8, fontSize: 12, color: '#8A9994',
                    borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: 8,
                    fontStyle: 'italic', lineHeight: 1.5,
                  }}>
                    {f.resumen_visita || f.observaciones_generales}
                  </div>
                )}

                <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                  <button
                    onClick={() => navigate(`/formularios/${f.id}`)}
                    style={{
                      flex: 1, background: '#12382D', color: '#4CAF50',
                      border: '1px solid rgba(79,175,80,0.2)', borderRadius: 8,
                      padding: '7px 10px', fontSize: 12, fontWeight: 600,
                      cursor: 'pointer', fontFamily: 'inherit',
                    }}>
                    📄 Ver comprobante
                  </button>
                  {f.pdf_url && (
                    <a href={f.pdf_url} target="_blank" rel="noopener noreferrer"
                      style={{
                        flex: 1, textAlign: 'center', background: '#0D1E2E',
                        color: '#38BDF8', border: '1px solid rgba(56,189,248,0.2)',
                        borderRadius: 8, padding: '7px 10px', fontSize: 12,
                        fontWeight: 600, textDecoration: 'none', display: 'block',
                      }}>
                      📁 Ver en Drive
                    </a>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }

  // ── Vista: ascensores de una comunidad ───────────────────────────────────────
  if (comunidadSel) {
    return (
      <div className="app-container">
        <div className="app-header">
          <button onClick={() => setComunidadSel(null)} className="back-btn">←</button>
          <h1>📊 {comunidadSel.comunidad}</h1>
        </div>

        <div style={{ background: '#0f6e56', padding: '10px 16px' }}>
          <p style={{ margin: 0, color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>
            {comunidadSel.direccion}
          </p>
          <p style={{ margin: '2px 0 0', color: 'rgba(255,255,255,0.65)', fontSize: 12 }}>
            {comunidadSel.comuna}
          </p>
        </div>

        <div className="page-content" style={{ padding: 12 }}>
          {ascensoresDeComunidad.map(a => (
            <div key={a.id} style={{
              background: '#161C19', borderRadius: 14, padding: 16,
              marginBottom: 10, display: 'flex', alignItems: 'center',
              border: '1px solid rgba(255,255,255,0.07)',
            }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12,
                background: '#12382D', border: '1px solid rgba(79,175,80,0.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22, flexShrink: 0, marginRight: 14,
              }}>
                🛗
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#F4F7F5' }}>{a.label}</div>
                <div style={{ fontSize: 12, color: '#8A9994', marginTop: 2 }}>
                  N° {a.n_ascensor} · Torre {a.torre}
                </div>
                {a.codigo && (
                  <div style={{ fontSize: 11, color: '#6B7C74', marginTop: 1 }}>{a.codigo}</div>
                )}
              </div>
              <button
                onClick={() => abrirBitacora(a)}
                style={{
                  background: '#12382D', color: '#4CAF50',
                  border: '1px solid rgba(79,175,80,0.2)',
                  borderRadius: 10, padding: '8px 14px', fontSize: 13,
                  fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                  fontFamily: 'inherit',
                }}>
                📋 Ver registros
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ── Vista: lista de comunidades ──────────────────────────────────────────────
  return (
    <div className="app-container">
      <div className="app-header">
        <button onClick={() => navigate('/')} className="back-btn">←</button>
        <h1>📊 Bitácoras</h1>
        <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>
          {comunidades.length}
        </span>
      </div>

      <div style={{
        background: '#111714', padding: '10px 16px',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        <input
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          placeholder="Buscar comunidad o comuna..."
          style={{
            width: '100%', padding: '10px 12px',
            border: '1.5px solid #2E4A40', borderRadius: 10,
            fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit',
            outline: 'none', background: '#0D1311', color: '#F4F7F5',
          }}
        />
      </div>

      <div className="page-content" style={{ padding: 12 }}>
        {loading ? (
          <div style={{ textAlign: 'center', paddingTop: 40 }}>
            <div className="spinner" />
          </div>
        ) : filtradas.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px 20px' }}>
            <p style={{ color: '#8A9994', fontSize: 14 }}>Sin resultados</p>
          </div>
        ) : (
          filtradas.map(c => (
            <div key={c.comunidad}
              onClick={() => setComunidadSel(c)}
              style={{
                background: '#161C19', borderRadius: 14, padding: 16,
                marginBottom: 10, display: 'flex', alignItems: 'center',
                border: '1px solid rgba(255,255,255,0.07)', cursor: 'pointer',
              }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12,
                background: '#12382D', border: '1px solid rgba(79,175,80,0.15)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 20, flexShrink: 0, marginRight: 14,
              }}>
                🏢
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#F4F7F5',
                  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {c.comunidad}
                </div>
                {c.direccion && (
                  <div style={{ fontSize: 12, color: '#8A9994', marginTop: 2,
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {c.direccion}
                  </div>
                )}
                <div style={{ fontSize: 11, color: '#6B7C74' }}>{c.comuna}</div>
              </div>
              <div style={{ textAlign: 'center', marginRight: 10, flexShrink: 0 }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#4CAF50' }}>
                  {c.ascensores.length}
                </div>
                <div style={{ fontSize: 10, color: '#6B7C74' }}>
                  {c.ascensores.length === 1 ? 'ascensor' : 'ascensores'}
                </div>
              </div>
              <span style={{ color: '#6B7C74', fontSize: 20 }}>›</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
